import { Box, Flex, Spinner } from "@chakra-ui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthenticationForm } from "../../../components/AuthenticationDialog/AuthenticationForm";
import { NewCard } from "../../../components/Card/Card";
import { store, useStoreData } from "../../../lib/store/store";

// The swipe deck itself — NOT /spark/atlanta/:id, which is a public event
// page and a perfectly good place to land.
const targetsSparkDeck = (target: string) =>
  target.split(/[?#]/)[0].toLowerCase().replace(/\/$/, "") === "/spark";

export const SignIn = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const storeData = useStoreData();
  // A link can send someone who is already signed in through here (the
  // reminder text's event link does, so a signed-out reader signs in first).
  // The form decides once, on mount, whether they are signed in, so wait for
  // the session to load rather than showing them the email step.
  if (storeData.loading) {
    return (
      <Flex justify="center" align="center" minH="60vh">
        <Spinner size="xl" />
      </Flex>
    );
  }
  return (
    <Box padding="2rem">
      <NewCard width="100%" maxWidth="35rem" marginX="auto">
        <AuthenticationForm
          confirmLabel="Sign in"
          onComplete={() => {
            const target = searchParams.get("r") || "/events";
            // Someone who signs up as friends only has no deck to return to:
            // a logged-out visit to /spark bounces through here with r=/spark,
            // so honoring it would hand a brand-new user the friends-mode
            // explainer as their first screen. Send them to events instead —
            // that's what the mode is for. Read the store at call time; the
            // flag was set moments ago on the previous screen.
            const friendsOnly = store.data.user?.friends_only ?? false;
            navigate(
              friendsOnly && targetsSparkDeck(target) ? "/events" : target
            );
          }}
        />
      </NewCard>
    </Box>
  );
};
